<template>
  <div class="pub-page">
    <div class="pub-header">
      <text class="title">{{$route.meta.title}}</text>
      <text class="title-secondary">( 请先完善个人信息，然后再进行评分 )</text>
    </div>
    <div class="pub-center">
      <div class="bg-white d-flex align-items-center flex-column py-4">
        <el-form v-loading="infoLoading" :model="form" size="large" label-width="auto" style="width: 100%;max-width: 600px" ref="ruleFormRef"
                 hide-required-asterisk :rules="rules">
          <el-form-item label="姓名：" prop="real_name">
            <div class="d-flex align-items-center justify-content-between w-100 ">
              <el-input v-model="form.real_name" class="me-2"  />
            </div>
          </el-form-item>
          <el-form-item label="单位：" prop="company">
            <div class="d-flex align-items-center justify-content-between w-100 ">
              <el-input v-model="form.company" class="me-2" />
            </div>
          </el-form-item>
          <el-form-item label="职称：" prop="title">
            <el-select
                v-model="form.title"
                placeholder="请选择"
                clearable
            >
              <el-option v-for="op in JOBLEVEL" :label="op.Name" :value="op.ID" :key="op.ID"/>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号："  prop="tel">
            <el-input v-model="form.tel" />
          </el-form-item>
          <el-form-item label="身份证号：" prop="id_card">
            <el-input v-model="form.id_card" />
          </el-form-item>
          <el-form-item label="银行账户：" prop="bank_card">
            <el-input v-model="form.bank_card"/>
          </el-form-item>
          <el-form-item label="开户行：" prop="bank_name">
            <el-input v-model="form.bank_name" placeholder="请输入开户行（精确到支行）"/>
            <div class="text-secondary small text-danger">提示：开户行请精确到支行</div>
          </el-form-item>
          <div class="w-100 px-3 d-flex align-items-center justify-content-center flex-column mt-4">
            <el-button type="primary" class="btn-save"
                       v-loading="loading"
                       @click="save"
            >保存
            </el-button>
          </div>
        </el-form>
      </div>

    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {JOBLEVEL} from "@/utils/commonSetting"
import {validateForm} from "@/utils/formValidate";
import {ElMessage} from "element-plus";
import {useStore} from "vuex";
import {updateJudge} from "@/api/special";
const store = useStore()
const loading = ref(false)
const userInfo = ref({})
const infoLoading = ref(true)
const ruleFormRef = ref()

const form = reactive({
  real_name:null,// 真实姓名
  company:null,// 单位
  title: null,//职称
  tel:null,// 电话
  id_card:null,// 身份证号
  bank_card:null,// 银行卡号
  bank_name:null,// 开户行
})
const rules = ({
  real_name: [{required: true, message: '请输入您的姓名', trigger: ['change','blur']}],
  company: [{required: true, message: '请输入工作单位', trigger: ['change','blur']}],
  title: [{required: true, message: '请输入职称', trigger: ['change','blur']}],
  bank_card: [{required: true, message: '请输入银行卡号', trigger: ['change','blur']}],
  bank_name: [{required: true, message: '请输入开户行', trigger: ['change','blur']}],
  tel: [
    {required: true, message: '请输入手机号', trigger: [ 'change','blur']},
    {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: ['change','blur']}
  ],
  id_card: [
    {required: true, message: '请输入身份证号', trigger: ['change', 'blur']},
    {pattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}[0-9Xx]$/, message: '请输入正确的身份证号', trigger: ['blur']}
  ],
})
onMounted( ()=>{
  getUserInfo() // 获取用户信息

})

const getUserInfo = async  ()=>{
  infoLoading.value = true
  await store.dispatch("loginModel/getUserInfo") //获取用户信息
  infoLoading.value = false
  const u = store.getters["loginModel/getUserInfo"] || {}
  form.real_name = u.real_name
  form.company = u.company
  form.title = u.title
  form.tel = u.tel
  form.id_card = u.id_card
  form.bank_card = u.bank_card
  form.bank_name = u.bank_name
}

const save = async ()=>{
  const isValid = await validateForm(ruleFormRef.value)
  if (!isValid) {
    return
  }
  loading.value = true
  const res = await updateJudge(form)
  loading.value = false
  if (res.success) {
    ElMessage.success("信息更新成功")
    getUserInfo() // 更新信息
  } else {
    ElMessage.warning(res.msg || "更新失败")
  }
}

</script>

<style scoped lang="scss">
.code {
  width: 110px;
  height: 40px;
  overflow: hidden;

  .code-img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
}
.btn-save {
  width: 200px;
  height: 40px;
}

</style>
